import img1 from '../assets/img/Remocoes/1.jpeg';
import img3 from '../assets/img/Remocoes/3.jpeg';
import img4 from '../assets/img/Remocoes/4.jpeg';
import img6 from '../assets/img/Remocoes/6.jpeg';
import img7 from '../assets/img/Remocoes/7.jpeg';
import img8 from '../assets/img/Remocoes/8.jpeg';
import img9 from '../assets/img/Remocoes/9.jpeg';
import img10 from '../assets/img/Remocoes/10.jpeg';
import img11 from '../assets/img/Remocoes/11.jpeg';
import img12 from '../assets/img/Remocoes/12.jpeg';
import img13 from '../assets/img/Remocoes/13.jpeg';
import img14 from '../assets/img/Remocoes/14.jpeg';
import img16 from '../assets/img/Remocoes/16.jpeg';
import img17 from '../assets/img/Remocoes/17.jfif';
import img18 from '../assets/img/Remocoes/18.jfif';
import img19 from '../assets/img/Remocoes/19.jfif';
import img20 from '../assets/img/Remocoes/20.jfif';
const items = [
    {
      id: 1,
      image: img1,
      imageBg: img1,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 3,
      image: img3,
      imageBg: img3,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 4,
      image: img4,
      imageBg: img4,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 6,
      image: img6,
      imageBg: img6,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 7,
      image: img7,
      imageBg: img7,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 8,
      image: img8,
      imageBg: img8,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 9,
      image: img9,
      imageBg: img9,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 10,
      image: img10,
      imageBg: img10,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 11,
      image: img11,
      imageBg: img11,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 12,
      image: img12,
      imageBg: img12,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 13,
      image: img13,
      imageBg: img13,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 14,
      image: img14,
      imageBg: img14,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 16,
      image: img16,
      imageBg: img16,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 17,
      image: img17,
      imageBg: img17,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 18,
      image: img18,
      imageBg: img18,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 19,
      image: img19,
      imageBg: img19,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
    {
      id: 20,
      image: img20,
      imageBg: img20,
      title: 'Carrinho 01',
      text: 'Com equipamentos apropriados e equipe técnica especializada, realizamos remoções internas horizontais e verticais de qualquer tipo de equipamentos.',
    },
  ];

  export default items;